import script from "./MobileHomePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileHomePage.vue?vue&type=script&setup=true&lang=ts"

import "./MobileHomePage.vue?vue&type=style&index=0&id=1fc74bec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fc74bec"]])

export default __exports__